import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import router from './routes/route';
import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(Meta)
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true

import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry);
				
Vue.prototype.$DOMAIN = () => {
	//本地
	//return process.env.VUE_APP_API_BASE_URL
	//return "https://"+localStorage.getItem("_domain")
	//测试
	//return "https://m2-test.crfchina.com/"
	return "https://m1.crfchina.com/"
}

new Vue({
	router,
	render: h => h(App),
	data() {
		
		}
}).$mount('#app')
